export const EMERGENCY_BANNER_SEVERITY_INFO = 'info';
export const EMERGENCY_BANNER_SEVERITY_WARNING = 'warning';
export const EMERGENCY_BANNER_SEVERITY_ERROR = 'error';

const emergencyBannerSeverities = [
    EMERGENCY_BANNER_SEVERITY_INFO,
    EMERGENCY_BANNER_SEVERITY_WARNING,
    EMERGENCY_BANNER_SEVERITY_ERROR,
] as const;

export type EmergencyBannerSeverity =
    (typeof emergencyBannerSeverities)[number];
